<script setup lang="ts">
import { useFilterStore } from '~/stores/useFilterStore'
import { useCategoryStore } from '~/stores/useCategoryStore'
import { Category, type BrandType, type CategoryType } from '~/types'

const props = defineProps<{ data: BrandType }>()

const router = useRouter()
const filterStore = useFilterStore()
const categoryStore = useCategoryStore()

const onClick = () => {
  const name = props.data.name
  if (!name) return

  const categories = props.data.categories || []
  let selectedCategory: CategoryType | undefined = undefined
  let route = ''

  if (categories.includes(Category.ENERGY) || categories.includes(Category.ELECTRICITY) || categories.includes(Category.GAS)) {
    selectedCategory = Category.ENERGY
    route = '/categoria/energia'
  } else if (categories.includes(Category.TELCO)) {
    selectedCategory = Category.TELCO
    route = '/categoria/telefonia'
  } else if (categories.includes(Category.INSURANCE)) {
    selectedCategory = Category.INSURANCE
    route = '/categoria/assicurazioni'
  }

  if (route && selectedCategory) {
    // Reset filters to avoid any conflict
    filterStore.resetFilters()
    // Set the category and supplier filter
    categoryStore.setCategory(selectedCategory)
    filterStore.setSupplier(name)
    // Navigate to the comparator
    router.push(route)
  } else if (props.data.externalUrl) {
    window.open(props.data.externalUrl, '_blank')
  }
}
</script>

<template>
  <!-- WCAG 2.1.1 — tabindex e keydown per navigazione tastiera; role=button per screen reader -->
  <div
    role="button"
    :title="data.name"
    :aria-label="`Vai alle offerte ${data.name}`"
    tabindex="0"
    @click="onClick"
    @keydown.enter="onClick"
    @keydown.space.prevent="onClick"
    class="flex flex-col items-center justify-center px-2 cursor-pointer hover:scale-110 focus-within:scale-110 focus-visible:scale-110 transition ease-in-out duration-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current rounded-lg">
    <NuxtImg class="h-24 object-contain"
      :src="data.assetUrl" :alt="`Logo ${data.name}`" width="144" height="96" />
  </div>
</template>